import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Outlet, useParams } from 'react-router-dom'
import type { Stores } from '../../../../util/store'

interface OrganizationWOModelManufacturerMatchProps {
    stores: Stores
}
export const OrganizationWOModelManufacturerMatch = observer(
    ({ stores }: OrganizationWOModelManufacturerMatchProps) => {
        const { organizationId } = useParams()
        useEffect(() => {
            stores.manufacturerModelMatch.load(organizationId!)
        }, [organizationId, stores.manufacturerModelMatch])

        return <Outlet />
    },
)
